<div class="container-fluid complyon-page cases-page px-3 px-md-4 px-xl-4 py-3">
  <div class="complyon-shell cases-shell mx-auto">
    <section class="mb-3">
      <h1 class="complyon-title cases-title mb-2 text-l">Incidents & cases</h1>
      <p class="complyon-subtitle cases-subtitle mb-0 text-s">Case intake, triage, investigation, corrective action, closure and lessons learned.</p>
    </section>

    <section class="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-3">
      <div class="d-flex flex-wrap align-items-center gap-1">
        <button
          v-for="tab in tabs"
          :key="tab.id"
          type="button"
          class="btn doa-tab-btn fw-semibold"
          :class="{ active: active_tab === tab.id }"
          @click="set_tab(tab.id)"
        >
          <span>{{ tab.label }}</span>
          <span v-if="tab.count !== undefined" class="doa-tab-count">{{ tab.count }}</span>
        </button>
      </div>

      <button type="button" class="btn doa-reset-btn d-inline-flex align-items-center gap-1">
        <i class="bi bi-arrow-clockwise"></i>
        <span>Reset sample</span>
      </button>
    </section>

    <div v-if="active_tab === 'cases'">
      <section class="row g-3 mb-3">
        <div v-for="card in case_cards" :key="card.label" class="col-12 col-md-6 col-xl-3">
          <article class="complyon-card rounded-4 p-3 h-100">
            <div class="complyon-stat-label text-xs">{{ card.label }}</div>
            <div class="complyon-stat-value text-l" :class="card.accent === 'red' ? 'text-danger' : card.accent === 'amber' ? 'text-warning-emphasis' : 'text-dark'">{{ card.value }}</div>
            <div class="complyon-stat-note mt-3 text-xs">{{ card.note }}</div>
          </article>
        </div>
      </section>

      <section class="complyon-panel rounded-4 overflow-hidden">
        <div class="d-flex align-items-start justify-content-between gap-2 px-3 pt-3">
          <div>
            <div class="complyon-section-title text-s">Case register</div>
            <div class="complyon-section-subtitle text-xs">Every incident with classification, severity score, investigator and workflow stage. Open one for the full case file.</div>
          </div>
          <button type="button" class="btn config-navbar-primary-action finance-action-btn" @click="open_report_modal">
            <i class="bi bi-plus-lg"></i>
            <span>Report incident</span>
          </button>
        </div>

        <div class="table-responsive">
          <table class="table complyon-table align-middle mb-0">
            <thead>
              <tr>
                <th class="ps-3 text-xs">Ref</th>
                <th class="text-xs">Case</th>
                <th class="text-xs">Classification</th>
                <th class="text-xs">Severity</th>
                <th class="text-xs">Investigator</th>
                <th class="text-xs">Stage</th>
                <th class="text-xs">Status</th>
                <th class="pe-3"></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="row in case_rows"
                :key="row.ref"
                class="cases-table-row"
                role="button"
                tabindex="0"
                @click="open_case_drawer(row)"
                @keydown.enter.prevent="open_case_drawer(row)"
                @keydown.space.prevent="open_case_drawer(row)"
              >
                <td class="ps-3 fw-semibold text-success">{{ row.ref }}</td>
                <td>
                  <div class="d-flex align-items-center gap-2">
                    <i v-if="row.lock" class="bi bi-lock text-secondary"></i>
                    <div class="cases-name">{{ row.case }}</div>
                  </div>
                </td>
                <td><span class="badge rounded-3 bg-light text-secondary border border-light">{{ row.classification }}</span></td>
                <td>
                  <div class="d-flex align-items-center gap-2">
                    <span class="badge rounded-3 bg-light text-secondary border border-light">{{ row.severity }}</span>
                    <span class="text-xs">{{ row.severity_label }}</span>
                  </div>
                </td>
                <td>{{ row.investigator }}</td>
                <td>{{ row.stage }}</td>
                <td><span class="badge complyon-badge text-xs" :class="row.status.class">{{ row.status.label }}</span></td>
                <td class="pe-3 text-end"><i class="bi bi-chevron-right finance-arrow"></i></td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>

    <div v-else-if="active_tab === 'investigations'">
      <section class="complyon-panel rounded-4 overflow-hidden cases-investigation-panel">
        <div class="px-3 pt-3 pb-2">
          <div class="complyon-section-title text-s">Investigation workflow</div>
          <div class="complyon-section-subtitle text-xs">Reported - Triage - Investigation - Corrective action - Closure. 8 active cases.</div>
        </div>

        <div class="px-3 pb-3 pt-2">
          <div class="cases-investigation-board">
            <article
              v-for="column in investigations_columns"
              :key="column.title"
              class="cases-investigation-column"
            >
              <div class="cases-investigation-column-head">
                <div class="cases-investigation-column-title">{{ column.title }}</div>
                <div class="cases-investigation-column-count">{{ column.count }}</div>
              </div>

              <div class="cases-investigation-column-body">
                <div
                  v-if="!column.items.length"
                  class="cases-investigation-empty"
                >
                  —
                </div>

                <article
                  v-for="item in column.items"
                  :key="item.ref"
                  class="cases-investigation-card"
                  role="button"
                  tabindex="0"
                  @click="open_case_drawer(item.ref)"
                  @keydown.enter.prevent="open_case_drawer(item.ref)"
                  @keydown.space.prevent="open_case_drawer(item.ref)"
                >
                  <div class="cases-investigation-card-head">
                    <div class="min-w-0">
                      <div class="cases-investigation-card-ref">{{ item.ref }}</div>
                      <div class="cases-investigation-card-title">{{ item.title }}</div>
                    </div>
                    <span class="cases-investigation-card-dot"></span>
                  </div>

                  <div class="cases-investigation-card-tag-row">
                    <span class="cases-investigation-card-tag">{{ item.subtitle }}</span>
                  </div>

                  <div class="cases-investigation-card-footer">
                    <span class="badge complyon-badge text-xs" :class="item.badge">{{ item.status }}</span>
                    <div class="cases-investigation-card-days">{{ item.days }}</div>
                  </div>
                </article>
              </div>
            </article>
          </div>
        </div>
      </section>
    </div>

    <div v-else-if="active_tab === 'by-type'">
      <section class="row g-3">
        <div v-for="group in type_cards" :key="group.type" class="col-12 col-md-6 col-xl-4">
          <article class="complyon-card rounded-4 p-3 h-100">
            <div class="d-flex align-items-start justify-content-between gap-3">
              <div class="complyon-section-title text-s">{{ group.type }}</div>
              <span class="badge rounded-pill" :class="group.badge === 'Critical' ? 'bg-danger-subtle text-danger-emphasis' : group.badge === 'High' ? 'bg-danger-subtle text-danger-emphasis' : 'bg-warning-subtle text-warning-emphasis'">{{ group.badge }}</span>
            </div>

            <div class="mt-2 d-flex align-items-center gap-2">
              <div class="complyon-stat-value text-l">{{ group.count }}</div>
              <div class="text-xs">cases</div>
              <div v-if="group.open" class="text-xs text-danger">{{ group.open }} open</div>
            </div>

            <div class="mt-3">
              <div
                v-for="item in group.rows"
                :key="`${group.type}-${item.ref}`"
                class="d-flex align-items-center justify-content-between gap-3 py-2"
                role="button"
                tabindex="0"
                @click="open_case_drawer(item.ref)"
                @keydown.enter.prevent="open_case_drawer(item.ref)"
                @keydown.space.prevent="open_case_drawer(item.ref)"
              >
                <div class="d-flex align-items-center gap-2 min-w-0">
                  <span class="rounded-circle flex-shrink-0" :style="{ width: '8px', height: '8px', backgroundColor: item.severity >= 12 ? '#c1261a' : '#c75a06' }"></span>
                  <div class="text-truncate">{{ item.ref }} {{ item.title }}</div>
                </div>
                <div class="fw-semibold text-xs">{{ item.severity }}</div>
              </div>
            </div>
          </article>
        </div>
      </section>
    </div>

    <div v-else-if="active_tab === 'repeat'">
      <section class="row g-3 mb-3">
        <div v-for="card in repeat_cards" :key="card.label" class="col-12 col-md-6 col-xl-3">
          <article class="complyon-card rounded-4 p-3 h-100">
            <div class="complyon-stat-label text-xs">{{ card.label }}</div>
            <div class="complyon-stat-value text-l" :class="card.accent === 'red' ? 'text-danger' : card.accent === 'amber' ? 'text-warning-emphasis' : 'text-dark'">{{ card.value }}</div>
            <div class="complyon-stat-note mt-3 text-xs">{{ card.note }}</div>
          </article>
        </div>
      </section>

      <section class="complyon-panel rounded-4 overflow-hidden cases-repeat-panel">
        <div class="px-3 pt-3">
          <div class="complyon-section-title text-s">Repeat incident detection</div>
          <div class="complyon-section-subtitle text-xs">Clusters of related cases - by category and by the same supplier or person. Recurrence signals a systemic root cause.</div>
        </div>

        <div class="px-3 pb-3 pt-3">
          <div class="row g-3 cases-repeat-grid">
            <div
              v-for="group in repeat_groups"
              :key="`${group.kind}-${group.title}`"
              class="col-12 col-md-6"
            >
              <article class="complyon-card rounded-4 p-3 h-100 cases-repeat-group">
                <div class="d-flex align-items-start justify-content-between gap-3 cases-repeat-group-head">
                  <div class="d-flex align-items-center gap-2 min-w-0">
                    <span
                      class="badge rounded-pill text-xs cases-repeat-kind"
                      :class="group.kind === 'ENTITY' ? 'is-entity' : 'is-category'"
                    >
                      {{ group.kind }}
                    </span>
                    <div class="procurement-name text-truncate cases-repeat-group-title">{{ group.title }}</div>
                  </div>
                  <span class="badge rounded-pill text-xs cases-repeat-count">{{ group.badge }}</span>
                </div>

                <div class="mt-3 d-flex flex-column gap-2 cases-repeat-list">
                  <div
                    v-for="item in group.items"
                    :key="`${group.title}-${item.ref}`"
                    class="d-flex align-items-center justify-content-between gap-3 cases-repeat-row"
                    role="button"
                    tabindex="0"
                    @click="open_case_drawer(item.ref)"
                    @keydown.enter.prevent="open_case_drawer(item.ref)"
                    @keydown.space.prevent="open_case_drawer(item.ref)"
                  >
                    <div class="d-flex align-items-center gap-2 min-w-0 cases-repeat-row-main">
                      <span
                        class="rounded-circle flex-shrink-0 cases-repeat-row-dot"
                        :class="item.status === 'Closed' ? 'is-success' : item.status === 'Escalated' ? 'is-danger' : 'is-warning'"
                      ></span>
                      <div class="min-w-0 cases-repeat-row-copy">
                        <div class="cases-repeat-row-title text-truncate">
                          <span class="cases-repeat-row-ref">{{ item.ref }}</span>
                          <span>{{ item.title }}</span>
                        </div>
                      </div>
                    </div>
                    <span
                      class="badge complyon-badge text-xs cases-repeat-row-status"
                      :class="item.status === 'Closed' ? 'bg-success-subtle text-success-emphasis' : item.status === 'Escalated' ? 'bg-danger-subtle text-danger-emphasis' : 'bg-warning-subtle text-warning-emphasis'"
                    >
                      {{ item.status }}
                    </span>
                  </div>
                </div>
              </article>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>

  <div v-if="active_case_drawer" class="command-centre-drawer-backdrop" @click="close_case_drawer"></div>

  <aside
    v-if="active_case_drawer"
    class="command-centre-drawer cases-detail-drawer"
    role="dialog"
    aria-modal="true"
    :aria-label="active_case_drawer.title"
    @click.stop
  >
    <header class="command-centre-drawer-header border-bottom cases-drawer-header">
      <div class="d-flex align-items-start justify-content-between gap-3">
        <div class="min-w-0">
          <div class="command-centre-drawer-kicker cases-drawer-kicker text-uppercase">{{ active_case_drawer.section }}</div>
          <h2 class="command-centre-drawer-title cases-drawer-title mt-2 mb-1">{{ active_case_drawer.title }}</h2>
          <div class="command-centre-drawer-subtitle cases-drawer-subtitle">{{ active_case_drawer.subtitle }}</div>
        </div>
        <div class="d-flex align-items-center gap-2 flex-shrink-0">
          <span :class="drawer_status_class(active_case_drawer.status)">{{ active_case_drawer.status }}</span>
          <button type="button" class="btn btn-link text-decoration-none p-0 command-centre-drawer-close cases-drawer-close" @click="close_case_drawer" aria-label="Close drawer">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>
      </div>
    </header>

    <div ref="caseDrawerBody" class="command-centre-drawer-body cases-drawer-body">
      <section v-if="active_case_drawer.repeat_alert" class="cases-drawer-alert mb-3">
        <div class="d-flex align-items-start gap-2">
          <i class="bi bi-arrow-repeat"></i>
          <div>{{ active_case_drawer.repeat_alert }}</div>
        </div>
      </section>

      <section class="cases-drawer-score-grid mb-4">
        <article class="cases-drawer-score-card is-score">
          <div class="cases-drawer-score-label">Severity score</div>
          <div class="cases-drawer-score-value">{{ active_case_drawer.score }}</div>
          <div class="cases-drawer-score-note">{{ active_case_drawer.score_note }}</div>
        </article>

        <article class="cases-drawer-score-card">
          <div class="cases-drawer-score-label">Severity</div>
          <div class="cases-drawer-score-pill">
            <span class="cases-drawer-score-dot"></span>
            <span>{{ active_case_drawer.severity }}</span>
          </div>
          <div class="cases-drawer-score-note">{{ active_case_drawer.classification }}</div>
        </article>

        <article class="cases-drawer-score-card">
          <div class="cases-drawer-score-label">Age</div>
          <div class="cases-drawer-age-value">{{ active_case_drawer.age }}</div>
          <div class="cases-drawer-score-note">since reported</div>
        </article>
      </section>

      <section class="mb-4">
        <div class="cases-drawer-section-label mb-2">Investigation workflow</div>
        <div class="cases-drawer-workflow">
          <div
            v-for="(step, index) in active_case_drawer.workflow"
            :key="`${active_case_drawer.section}-${step.label}`"
            class="cases-drawer-workflow-step"
            :class="`is-${step.state}`"
          >
            <span class="cases-drawer-workflow-dot">{{ index + 1 }}</span>
            <span class="cases-drawer-workflow-text">{{ step.label }}</span>
          </div>
        </div>
      </section>

      <section class="cases-drawer-summary mb-4">
        <div class="d-flex align-items-start gap-2">
          <span class="cases-drawer-summary-icon">
            <i class="bi" :class="active_case_drawer.summary_icon"></i>
          </span>
          <div>
            <div class="cases-drawer-summary-title">{{ active_case_drawer.summary_heading }}</div>
            <div class="cases-drawer-summary-copy">{{ active_case_drawer.summary_copy }}</div>
          </div>
        </div>
      </section>

      <section class="mb-4">
        <div class="cases-drawer-section-head">
          <span>Connected records</span>
        </div>
        <div class="cases-drawer-record-grid">
          <article v-for="record in active_case_drawer.connected_records" :key="`${record.type}-${record.title}`" class="cases-drawer-record-card">
            <div class="d-flex align-items-start justify-content-between gap-2">
              <div class="d-flex align-items-start gap-2 min-w-0">
                <span class="cases-drawer-record-icon">
                  <i class="bi" :class="record_icon_for_type(record.type)"></i>
                </span>
                <div class="min-w-0">
                  <div class="cases-drawer-record-type">{{ record.type }}</div>
                  <div class="cases-drawer-record-title">{{ record.title }}</div>
                </div>
              </div>
              <i class="bi bi-box-arrow-up-right cases-drawer-record-link"></i>
            </div>
          </article>
        </div>
      </section>

      <section class="mb-4">
        <div class="cases-drawer-section-head d-flex align-items-center justify-content-between gap-2">
          <span>Evidence collected</span>
          <button type="button" class="btn btn-link text-decoration-none p-0 cases-drawer-inline-btn">
            <i class="bi bi-plus-lg"></i>
            <span>Collect</span>
          </button>
        </div>
        <div class="d-flex flex-column gap-2">
          <article v-for="item in active_case_drawer.evidence" :key="item.title" class="cases-drawer-list-card">
            <div class="d-flex align-items-start gap-2">
              <span class="cases-drawer-list-icon">
                <i class="bi bi-file-earmark-text"></i>
              </span>
              <div>
                <div class="cases-drawer-list-title">{{ item.title }}</div>
                <div class="cases-drawer-list-subtitle">{{ item.subtitle }}</div>
              </div>
            </div>
          </article>
        </div>
      </section>

      <section class="mb-4">
        <div class="cases-drawer-section-head d-flex align-items-center justify-content-between gap-2">
          <span>Root cause analysis</span>
          <button type="button" class="btn btn-link text-decoration-none p-0 cases-drawer-inline-btn">
            <i class="bi" :class="active_case_drawer.root_cause_tags.length ? 'bi-pencil-square' : 'bi-plus-lg'"></i>
            <span>{{ active_case_drawer.root_cause_tags.length ? 'Edit' : 'Add' }}</span>
          </button>
        </div>
        <div class="cases-drawer-root-copy">{{ active_case_drawer.root_cause_summary }}</div>
        <div v-if="active_case_drawer.root_cause_tags.length" class="d-flex flex-wrap gap-2 mt-2">
          <span v-for="tag in active_case_drawer.root_cause_tags" :key="tag" class="command-centre-drawer-chip is-slate">{{ tag }}</span>
        </div>
      </section>

      <section class="mb-4">
        <div class="cases-drawer-section-head d-flex align-items-center justify-content-between gap-2">
          <span>Corrective actions</span>
          <button type="button" class="btn btn-link text-decoration-none p-0 cases-drawer-inline-btn">
            <i class="bi bi-plus-lg"></i>
            <span>Add</span>
          </button>
        </div>
        <div class="d-flex flex-column gap-2">
          <article v-for="action in active_case_drawer.corrective_actions" :key="action.title" class="cases-drawer-list-card">
            <div class="d-flex align-items-start justify-content-between gap-3">
              <div class="d-flex align-items-start gap-2 min-w-0">
                <span class="cases-drawer-list-icon is-action">
                  <i class="bi bi-check2-square"></i>
                </span>
                <div class="min-w-0">
                  <div class="cases-drawer-list-title">{{ action.title }}</div>
                  <div class="cases-drawer-list-subtitle">{{ action.subtitle }}</div>
                </div>
              </div>
              <span class="badge rounded-pill flex-shrink-0" :class="action_status_class(action.status)">{{ action.status }}</span>
            </div>
          </article>
        </div>
      </section>

      <section v-if="active_case_drawer.escalations.length" class="mb-4">
        <div class="cases-drawer-section-head">
          <span>Escalations</span>
        </div>
        <div class="d-flex flex-column gap-2">
          <article v-for="item in active_case_drawer.escalations" :key="item.title" class="cases-drawer-list-card">
            <div class="d-flex align-items-start gap-2">
              <span class="cases-drawer-list-icon is-escalation">
                <i class="bi bi-arrow-up-right"></i>
              </span>
              <div>
                <div class="cases-drawer-list-title">{{ item.title }}</div>
                <div class="cases-drawer-list-subtitle">{{ item.subtitle }}</div>
              </div>
            </div>
          </article>
        </div>
      </section>

      <section v-if="active_case_drawer.closure_report" class="mb-2">
        <div class="cases-drawer-section-head">
          <span>Closure report</span>
        </div>
        <article class="cases-drawer-closure-card">
          <div class="d-flex align-items-start justify-content-between gap-2">
            <div class="cases-drawer-closure-title">{{ active_case_drawer.closure_report.title }}</div>
            <div class="cases-drawer-closure-meta">{{ active_case_drawer.closure_report.meta }}</div>
          </div>
          <div class="cases-drawer-closure-copy">{{ active_case_drawer.closure_report.summary }}</div>
          <div class="cases-drawer-closure-lesson">
            <strong>Lessons learned:</strong> {{ active_case_drawer.closure_report.lesson }}
          </div>
        </article>
      </section>
    </div>

    <footer class="command-centre-drawer-footer border-top cases-drawer-footer">
      <span v-if="active_case_drawer.confidential" class="command-centre-drawer-chip is-slate">
        <i class="bi bi-lock"></i>
        <span>Confidential</span>
      </span>
      <button type="button" class="btn btn-link text-decoration-none p-0 cases-drawer-footer-link ms-auto">
        <i class="bi bi-pencil-square"></i>
        <span>Edit</span>
      </button>
      <button v-if="active_case_drawer.can_escalate" type="button" class="btn btn-link text-decoration-none p-0 cases-drawer-footer-link">
        <i class="bi bi-arrow-up"></i>
        <span>Escalate</span>
      </button>
      <button type="button" class="btn config-navbar-primary-action d-inline-flex align-items-center gap-2">
        <i class="bi" :class="active_case_drawer.primary_action_icon"></i>
        <span>{{ active_case_drawer.primary_action_label }}</span>
      </button>
    </footer>
  </aside>

  <div v-if="report_modal_open" class="finance-modal-backdrop" @click.self="close_report_modal">
    <section class="finance-modal-shell" role="dialog" aria-modal="true" aria-label="Report incident">
      <header class="finance-modal-header d-flex align-items-start justify-content-between gap-3 border-bottom">
        <div>
          <div class="finance-modal-title">Report incident</div>
          <div class="finance-modal-subtitle">Evidence, root cause, corrective actions and closure are managed in the case file.</div>
        </div>
        <button type="button" class="btn btn-link p-0 finance-modal-close" @click="close_report_modal" aria-label="Close modal">
          <i class="bi bi-x-lg"></i>
        </button>
      </header>

      <div class="finance-modal-body">
        <div class="row g-3">
          <div class="col-12">
            <label class="finance-modal-label">Incident title</label>
            <input v-model="report_form.title" type="text" class="form-control finance-modal-input" placeholder="What happened">
          </div>

          <div class="col-12">
            <label class="finance-modal-label">Description</label>
            <textarea v-model="report_form.description" rows="3" class="form-control finance-modal-textarea" placeholder="Describe the incident"></textarea>
          </div>

          <div class="col-12 col-md-6">
            <label class="finance-modal-label">Case classification</label>
            <select v-model="report_form.classification" class="form-select finance-modal-input">
              <option v-for="option in case_classification_options" :key="option" :value="option">{{ option }}</option>
            </select>
          </div>

          <div class="col-12 col-md-6">
            <label class="finance-modal-label">Assigned investigator</label>
            <input v-model="report_form.investigator" type="text" class="form-control finance-modal-input" placeholder="Role - name">
          </div>

          <div class="col-12 col-md-6">
            <label class="finance-modal-label">Reported by</label>
            <input v-model="report_form.reported_by" type="text" class="form-control finance-modal-input" placeholder="Reporter name">
          </div>

          <div class="col-12 col-md-6">
            <label class="finance-modal-label">Workflow stage</label>
            <select v-model="report_form.workflow_stage" class="form-select finance-modal-input">
              <option v-for="option in workflow_stage_options" :key="option" :value="option">{{ option }}</option>
            </select>
          </div>

          <div class="col-12">
            <div class="finance-modal-label">Severity scoring - impact x reach</div>
          </div>

          <div class="col-12 col-md-6">
            <label class="finance-modal-label">Impact</label>
            <select v-model="report_form.impact" class="form-select finance-modal-input">
              <option v-for="option in impact_options" :key="option" :value="option">{{ option }}</option>
            </select>
          </div>

          <div class="col-12 col-md-6">
            <label class="finance-modal-label">Reach / exposure</label>
            <select v-model="report_form.reach" class="form-select finance-modal-input">
              <option v-for="option in reach_options" :key="option" :value="option">{{ option }}</option>
            </select>
          </div>

          <div class="col-12 col-md-6">
            <label class="finance-modal-label">Status</label>
            <select v-model="report_form.status" class="form-select finance-modal-input">
              <option v-for="option in case_status_options" :key="option" :value="option">{{ option }}</option>
            </select>
          </div>

          <div class="col-12 col-md-6 d-flex align-items-end">
            <div class="form-check mb-2">
              <input id="incident-confidential" v-model="report_form.confidential" class="form-check-input" type="checkbox">
              <label class="form-check-label" for="incident-confidential">
                Confidential case - restrict access to investigator & compliance
              </label>
            </div>
          </div>
        </div>
      </div>

      <footer class="finance-modal-footer d-flex align-items-center justify-content-end gap-2 border-top">
        <button type="button" class="btn btn-link finance-modal-cancel text-decoration-none" @click="close_report_modal">Cancel</button>
        <button type="button" class="btn config-navbar-primary-action d-inline-flex align-items-center gap-2" @click="submit_report_modal">
          <i class="bi bi-plus-lg"></i>
          <span>Report</span>
        </button>
      </footer>
    </section>
  </div>
</div>
